import { Component, OnDestroy, OnInit } from "@angular/core"
import { IWindowResizeEvent, WindowSizeService } from "../../services/window-size.service"
import { slideIn } from "../../design-system/burger-menu/burger-menu.component"
import { map, takeUntil, tap } from "rxjs/operators"
import { Observable, ReplaySubject } from "rxjs"
import { ABOUT_ROUTES } from "../../services/about.service"

@Component({
    selector: "app-about-mobile-menu",
    templateUrl: "./about-mobile-menu.component.html",
    styleUrls: ["./about-mobile-menu.component.scss"],
    animations: [slideIn],
})
export class AboutMobileMenuComponent implements OnInit, OnDestroy {
    isMenuCollapsed = false
    gtmPrefix = "gtm-header-dropdown-"
    isTablet$: Observable<boolean>
    destroyed$: ReplaySubject<boolean> = new ReplaySubject(1)
    aboutRoutes = [...ABOUT_ROUTES]

    constructor(public windowSize: WindowSizeService) {}

    ngOnInit() {
        this.isTablet$ = this.windowSize.resize.pipe(
            takeUntil(this.destroyed$),
            tap((data) => (!data.isTablet ? (this.isMenuCollapsed = false) : null)),
            map((data: IWindowResizeEvent) => data.isTablet)
        )
    }

    displayMenu(event) {
        this.isMenuCollapsed = event
    }

    checkIfActiveRoute(link: string) {
        return window.location.pathname.includes(link)
    }

    ngOnDestroy(): void {
        this.destroyed$.next(true)
        this.destroyed$.complete()
    }
}
